const getPackageIdFromOrderItems = (payload) => {
    const orderItems = payload?.booking?.payment?.order?.items
        ?? payload?.payment?.order?.items
        ?? [];

    const packageItem = orderItems.find(
        (item) => item?.kind === 'package' || item?.product?.kind === 'package'
    );

    return packageItem?.payload?.service_package_id
        ?? packageItem?.payload?.id
        ?? packageItem?.service_package_id
        ?? packageItem?.product?.id
        ?? null;
};

export const getBookingPackageIdFromSlots = (slots = [], payload = null) => {
    const fromPayload = payload?.service_package_id
        ?? payload?.booking?.service_package_id
        ?? payload?.booking?.payment?.package_summary?.service_package_id
        ?? payload?.payment?.package_summary?.service_package_id;

    if (fromPayload) return fromPayload;

    const fromOrder = getPackageIdFromOrderItems(payload);
    if (fromOrder) return fromOrder;

    for (const slot of slots) {
        if (slot?.service_package_id) return slot.service_package_id;
    }

    return null;
};
